<template>
    <footer class="bg-[#0F172A] py-8">
        <div class="container lg:mx-auto flex flex-col items-center lg:gap-3">
            <div class="flex flex-col items-center mt-2">
                <a href="#" class="flex items-center justify-center mb-1">
                    <!-- <img :src="logo_image" alt="Logo" /> -->
                    <img :src="logo_image" alt="Logo" class="w-28 py-4 object-fit" />

                </a>
                <p class="text-white lg:text-base font-semibold text-center mt-2">Learning Management System</p>
            </div>

            <div class="flex justify-center space-x-4 mt-3">
                <!-- <a href="#" target="_blank">
                    <img src="@/assets/newd/linkedin.svg" alt="LinkedIn"
                        class="hover:opacity-80 object-contain w-8 h-8 rounded-full" />
                </a> -->
                <a href="https://www.facebook.com/online.alliance" target="_blank">
                    <img src="@/assets/newd/facebook.svg" alt="Facebook"
                        class="hover:opacity-80 object-contain w-8 h-8 rounded-full" />
                </a>
                <a href="https://www.instagram.com/online.alliance/" target="_blank">
                    <img src="@/assets/newd/instgram.svg" alt="Instagram"
                        class="hover:opacity-80 object-contain w-8 h-8 rounded-full" />
                </a>
                <a href="https://x.com/_onlinealliance" target="_blank">
                    <img src="@/assets/newd/twitter.svg" alt="Twitter"
                        class="hover:opacity-80 object-contain w-8 h-8 rounded-full" />
                </a>
            </div>


        </div>

        <hr class="border-gray-600 my-6" />

       <!-- <div class="text-center text-white text-sm py-2">
            © {{ new Date().getFullYear() }}, Ed suite Private Limited. All rights reserved |
            Powered by <a href="https://galecta.com/" class="text-blue-400 hover:underline">Alliance</a>
        </div> -->
    </footer>
</template>

<script>
export default {
    data() {
        return {
             logo_image: require(`${process.env.VUE_APP_COMS_LOGO}`),
            title: "",
        };
    },
    created() {
        this.title = process.env.VUE_APP_Title;
    },
};
</script>
